import { GET_PRODUCTS, PRODUCTS_ERROR } from "../types";
import axios from "axios";
import axiosRetry from "axios-retry";
import * as Sentry from "@sentry/nextjs";
import GTM from 'react-gtm-module';
import { hotjar } from "react-hotjar";

import {
  KEY_ORDER_INFO,
  setItemSessionStorage,
} from "../../variables/Variables";
import { createLeadEventBody } from "../../helpers/analytics";

export const address = (orderInfo, addressId) => {
  return {
    address1: orderInfo[addressId + "Address1"],
    address2: orderInfo[addressId + "Address2"],
    city: orderInfo[addressId + "City"],
    state: orderInfo[addressId + "State"],
    zip: orderInfo[addressId + "Zip"],
    country: orderInfo[addressId + "Country"],
    county: orderInfo[addressId + "County"],
  };
};

export const customer = (orderInfo) => {
  return {
    email: orderInfo.customerEmail,
    phone: orderInfo.customerPhone.replace(/\D/g, ""),
  };
};

export const activity = (product, orderInfo) => {
  product.activityReasonForApplying = orderInfo.activityReasonForApplying;
  product.activityPrimaryActivity = orderInfo.activityPrimaryActivity;
  product.activitySpecificProducts = orderInfo.activitySpecificProducts;

  if (orderInfo.productDescription) {
    product.productDescription = orderInfo.productDescription;
  }

  if (orderInfo.productExtraQuestion1) {
    product.productExtraQuestion1 = orderInfo.productExtraQuestion1;
  }

  if (orderInfo.productExtraQuestion2) {
    product.productExtraQuestion2 = orderInfo.productExtraQuestion2;
  }

  if (orderInfo.productExtraQuestion3) {
    product.productExtraQuestion3 = orderInfo.productExtraQuestion3;
  }

  if (orderInfo.productExtraQuestion4) {
    product.productExtraQuestion4 = orderInfo.productExtraQuestion4;
  }
};

export const questions = (product, orderInfo) => {
  if (orderInfo.acceptCreditCardPayments) product.acceptCreditCardPayments = !(orderInfo.acceptCreditCardPayments === "false");
  if (orderInfo.payEmployeesViaPayroll) product.payEmployeesViaPayroll = !(orderInfo.payEmployeesViaPayroll === "false");
  if (orderInfo.questionsHighway) product.questionsHighway = !(orderInfo.questionsHighway === "false");
  if (orderInfo.questionsGambling) product.questionsGambling = !(orderInfo.questionsGambling === "false");
  if (orderInfo.questionsATF) product.questionsATF = !(orderInfo.questionsATF === "false");
  if (orderInfo.questionsExcise) product.questionsExcise = !(orderInfo.questionsExcise === "false");
  if (orderInfo.questionsAppliedBefore) product.questionsAppliedBefore = !(orderInfo.questionsAppliedBefore === "false");
  if (orderInfo.questionsHire) product.questionsHire = !(orderInfo.questionsHire === "false");
  if (product.questionsAppliedBefore) {
    product.previousEINNumberFirst2 = orderInfo.previousEINNumberFirst2;
    product.previousEINNumberLast7 = orderInfo.previousEINNumberLast7;
  }
  if (product.questionsHire) {
    product.payLessThan4k = !(orderInfo.payLessThan4k === "false");
    if (product.payLessThan4k) {
      product.annualTaxes = !(orderInfo.annualTaxes === "false");
    }
    product.numberOfAgricultureEmployees = parseInt(orderInfo.numberOfAgricultureEmployees);
    product.numberOfHouseholdeEmployees = parseInt(orderInfo.numberOfHouseholdeEmployees);
    product.numberOfOtherEmployees = parseInt(orderInfo.numberOfOtherEmployees);
    product.firstDateWages = date(orderInfo, "firstDateWages");
  }
};
export const person = (orderInfo, personId) => {
  return {
    firstName: orderInfo[personId + "FirstName"],
    middleName: orderInfo[personId + "MiddleName"],
    lastName: orderInfo[personId + "LastName"],
    suffixName:
      orderInfo[personId + "SuffixName"] && orderInfo[personId + "SuffixName"].length > 0
        ? orderInfo[personId + "SuffixName"]
        : null,
    title: orderInfo[personId + "Title"],
    ssn: orderInfo[personId + "SSN"],
  };
};
export const date = (orderInfo, dateId) => {
  const year = parseInt(orderInfo[dateId + "Year"]);
  const month = parseInt(orderInfo[dateId + "Month"]) - 1; // to start from 0
  const day = parseInt(orderInfo[dateId + "Day"]);

  return new Date(year, month, day, 10, 0, 0).toISOString().slice(0, 19);
};

export const getProducts = () => async (dispatch) => {
  try {
    const res = await axios.get(process.env.NEXT_PUBLIC_REACT_APP_API + "/category/EIN/products/codes");
    if (res) {
      dispatch({
        type: GET_PRODUCTS,
        payload: res.data,
      });
    }

    return res;
  } catch (err) {
    try {
      let salePage = window.location.href;
      let salePageURLArr = salePage.split("/");
      let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(
        /\/+$/,
        ""
      );
      const res2 = await axios.get(salePageURL + "/crm/category/EIN/products/codes");

      dispatch({
        type: GET_PRODUCTS,
        payload: res2.data,
      });
    } catch (e2) {
      if (e2.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx

        dispatch({
          type: PRODUCTS_ERROR,
        });
      } else if (e2.request) {
        dispatch({
          type: PRODUCTS_ERROR,
        });
      } else {
        dispatch({
          type: PRODUCTS_ERROR,
        });
      }

      Sentry.captureException(new Error("Get products codes error"), {
        tags: {
          section: "products",
        },
      });
    }
  }
};

export const getIncProducts = () => async (dispatch) => {
  try {
    const res = await axios.get(process.env.NEXT_PUBLIC_REACT_APP_API + "/category/EIN_INC/products/codes");
    if (res) {
      dispatch({
        type: GET_PRODUCTS,
        payload: res.data,
      });
    }

    return res;
  } catch (err) {
    try {
      let salePage = window.location.href;
      let salePageURLArr = salePage.split("/");
      let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(
        /\/+$/,
        ""
      );
      const res2 = await axios.get(salePageURL + "/crm/category/EIN_INC/products/codes");

      dispatch({
        type: GET_PRODUCTS,
        payload: res2.data,
      });
    } catch (e2) {
      if (e2.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx

        dispatch({
          type: PRODUCTS_ERROR,
        });
      } else if (e2.request) {
        dispatch({
          type: PRODUCTS_ERROR,
        });
      } else {
        dispatch({
          type: PRODUCTS_ERROR,
        });
      }

      Sentry.captureException(new Error("Get products codes error"), {
        tags: {
          section: "products",
        },
      });
    }
  }
};

/* Product actions */
export const trustEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      trustType: orderInfo.trustType,
      corpAddress: address(orderInfo, "trusteeAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      creater: person(orderInfo, "creater"),
      trustee: person(orderInfo, "trustee"),
      dbaname: orderInfo.dbaname,
    };

    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const estateEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      corpAddress: address(orderInfo, "representativeAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      dateOfDeath: date(orderInfo, "dateOfDeath"),
      closingMonth: orderInfo.closingMonth,
      deceased: person(orderInfo, "deceased"),
      representative: person(orderInfo, "representative"),
      dbaname: orderInfo.dbaname,
    };
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const nonProfitEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      nonProfitType: orderInfo.nonProfitType,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      responsibleParty: person(orderInfo, "responsibleParty"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const churchEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      responsibleParty: person(orderInfo, "responsibleParty"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = {products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const partnershipEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      primaryPartner: person(orderInfo, "primaryPartner"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const pSCEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      principalOfficer: person(orderInfo, "principalOfficer"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const logOrder = (orderInfo) => {
  let crmSessionId;
  if (localStorage.getItem("crmSessionId")) {
    crmSessionId = localStorage.getItem("crmSessionId");
  }
  return (dispatch) => {
    dispatch(logStarted());
    return axios
      .post(
        process.env.NEXT_PUBLIC_REACT_APP_API + "/customers/" + crmSessionId + "/ui-logs",
        JSON.stringify(orderInfo),
        {
          headers: {
            "Content-Type": "html/text",
          },
        }
      )
      .then((response) => {
        dispatch(logSuccess(response.data));
      })
      .catch((error) => {
        let salePage = window.location.href;
        let salePageURLArr = salePage.split("/");
        let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(
          /\/+$/,
          ""
        );
        axios
          .post(salePageURL + "/crm/customers/" + crmSessionId + "/ui-logs", JSON.stringify(orderInfo), {
            headers: {
              "Content-Type": "html/text",
            },
          })
          .then((response) => {
            dispatch(logSuccess(response.data));
          })
          .catch((error) => {
            dispatch(logFailure(error));
          });
      });
  };
};

export const cCorpEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      principalOfficer: person(orderInfo, "principalOfficer"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);

    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const sCorpEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      principalOfficer: person(orderInfo, "principalOfficer"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const llcEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      legalName: orderInfo.legalName,
      numberOfMembers: orderInfo.LLCMembers,
      organizedState: orderInfo.organizedState,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      owner: person(orderInfo, "owner"),
      taxClassification: orderInfo.taxClassification,
      dbaname: orderInfo.dbaname,
    };
    if (orderInfo.LLCMembers === "2") {
      product.husbandAndWife = orderInfo.husbandAndWife;
      if (orderInfo.husbandAndWife === "true") product.multiMember = orderInfo.multiMember;
    }
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const solePropEinOrder = (orderInfo, history) => {
  return (dispatch) => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      startDate: date(orderInfo, "startDate"),
      closingMonth: orderInfo.closingMonth,
      corpAddress: address(orderInfo, "corpAddress"),
      altAddress: orderInfo.altAddress === "false" ? null : address(orderInfo, "altAddress"),
      owner: person(orderInfo, "owner"),
      dbaname: orderInfo.dbaname,
    };
    activity(product, orderInfo);
    questions(product, orderInfo);
    const order = { products: [product], customer: customer(orderInfo) };
    order.order ? (order.order.device = orderInfo.device) : (order.order = { device: orderInfo.device });
    dispatch(orderCreate(order, history));
  };
};

export const llcIncOrder = (orderInfo, history) => {
  return dispatch => {
    const product = {
      code: orderInfo.code,
      customerName: orderInfo.customerName,
      companyName: orderInfo.tradeName,
      altCompanyName: orderInfo.altCompanyName,
      organizedState: orderInfo.organizedState,
      designator: orderInfo.designator,
      principalOfficer: {
        firstName: orderInfo.principalOfficerFirstName,
        middleName: orderInfo.principalOfficerMiddleName,
        lastName: orderInfo.principalOfficerLastName,
      },
      corporateAddress: {
        address1: orderInfo.physicalAddressAddress,
        city: orderInfo.physicalAddressCity,
        state: orderInfo.physicalAddressState,
        zip: orderInfo.physicalAddressZip,
        county: orderInfo.physicalAddressCounty,
        country: "US",
      },
      mailingAddress: {
        address1: orderInfo.mailingAddressAddress,
        city: orderInfo.mailingAddressCity,
        state: orderInfo.mailingAddressState,
        zip: orderInfo.mailingAddressZip,
        county: orderInfo.mailingAddressCounty,
        country: "US",
      },
      managedByMembers: orderInfo.managedByMembers,
      managedByManagers: orderInfo.managedByManagers,
    };

    if (orderInfo.managedByMembers === "true") {
      product.members = [...orderInfo.members];
    } else {
      product.members = [...orderInfo.managers];
    }

    activity(product, orderInfo);

    const { activityReasonForApplying, ...restProduct } = product;

    const newOrder = {
      products: [restProduct, ...(orderInfo.linkedProducts || [])?.map(({ code }) => ({ code, state: orderInfo.organizedState }))],
      customer: {
        firstName: orderInfo.customerFirstName,
        lastName: orderInfo.customerLastName,
        email: orderInfo.customerEmail,
        phone: orderInfo.customerPhone.replace(/\D/g, ""),
      },
      order: { 
        device: orderInfo.device,
      },
    };

    if (history.query.campaignId) {
      newOrder.order.campaignId = history.query.campaignId;
    }

    dispatch(orderCreate(newOrder, history));
  };
};

export const orderCreate = (order, history) => {
  if (localStorage.getItem("gclid")) {
    order.order
      ? (order.order.clid = localStorage.getItem("gclid"))
      : (order.order = { clid: localStorage.getItem("gclid") });
  }

  if (localStorage.getItem("source")) {
    order.order
      ? (order.order.source = localStorage.getItem("source"))
      : (order.order = { source: localStorage.getItem("source") });
  }

  if (localStorage.getItem("keyword")) {
    order.order
      ? (order.order.keyword = localStorage.getItem("keyword"))
      : (order.order = { keyword: localStorage.getItem("keyword") });
  }

  if (localStorage.getItem("adAccount")) {
    order.order
      ? (order.order.adAccount = localStorage.getItem("adAccount"))
      : (order.order = { adAccount: localStorage.getItem("adAccount") });
  }

  let params;
  if (localStorage.getItem("crmSessionId")) {
    let crmSessionId = localStorage.getItem("crmSessionId");
    params = { crmSessionId };
  }
  let salePage = window.location.href;
  let salePageURLArr = salePage.split("/");
  let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2] +
    process.env.NEXT_PUBLIC_BASE_PATH).replace(
    /\/+$/,
    ""
  );
  order.order ? (order.order.salePageURL = salePageURL) : (order.order = { salePageURL: salePageURL });

  return (dispatch) => {
    dispatch(orderStarted());
    axiosRetry(axios, { retries: 10 });

    return axios
      .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/category/products", order, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      })
      .then(response => {
        try {
          const data = JSON.parse(JSON.stringify(response.data));
          return { ...response, data };
        } catch(e) {
          throw { error: e, payload: { response } };
        }
      })
      .then((response) => {
        // send success action
        // response.data.isUpsell =
        //     history.pathname.replace("/products/", "") === "EINSoleProp"
        //         ? true
        //         : false;
        dispatch(orderSuccess(response.data));

        // cache order info
        if (localStorage) {
          setItemSessionStorage(KEY_ORDER_INFO, response.data);
        }
        GTM.dataLayer(createLeadEventBody(order));

        hotjar.event("payment_reached");

        if (localStorage.getItem("path")?.startsWith("INC")) {
          history.push("/incorps/payment");
        } else {
          history.push("/payment");
        }
      })
      .catch((error) => {
        if (error.response) {
          // client received an error response (5xx, 4xx)
          if (error.response.data) {
            dispatch(
              orderFailure({
                message: `${error.response.data.code || ""}${error.response.data.code ? ": " : ""}${error.response.data.message || "Something went wrong"}`,
              })
            );
          } else {
            dispatch(orderFailure({ message: "Error" }));
          }
        } else if (error.request) {
          // client never received a response, or request never left
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(
            /\/+$/,
            ""
          );
          axios
            .post(salePageURL + "/crm/category/products", order, {
              headers: {
                "Content-Type": "application/json",
              },
              params,
            })
            .then(response2 => {
              try {
                const data = JSON.parse(JSON.stringify(response2.data));
                return { ...response2, data };
              } catch(e) {
                throw { error: e, payload: { response2 } };
              }
            })
            .then((response2) => {
              // send success action
              // response2.data.isUpsell =
              //     history.pathname.replace("/products/", "") === "EINSoleProp"
              //         ? true
              //         : false;
              dispatch(orderSuccess(response2.data));

              // cache order info
              if (localStorage) {
                setItemSessionStorage(KEY_ORDER_INFO, response2.data);
              }
              GTM.dataLayer(createLeadEventBody(order));
              
              hotjar.event("payment_reached");
              
              if (localStorage.getItem("path")?.startsWith("INC")) {
                history.push("/incorps/payment");
              } else {
                history.push("/payment");
              }
            })
            .catch((error2) => {
              if (error2.response) {
                // client received an error response (5xx, 4xx)
                if (error2.response.data) {
                  dispatch(
                    orderFailure({
                      message: `${error2.response.data.code || ""}${error2.response.data.code ? ": " : ""}${error2.response.data.message || "Something went wrong"}`,
                    })
                  );
                } else {
                  dispatch(orderFailure({ message: "Error" }));
                }
              } else if (error2.request) {
                // client never received a response, or request never left
                dispatch(orderFailure({ message: "Network Error" }));
              } else {
                dispatch(orderFailure({ message: error2.message || "Something went wrong" }));
              }
              Sentry.captureException(error2);
              Sentry.captureException(new Error("Create order error"), {
                tags: {
                  section: "products",
                },
              });
            });
        } else {
          Sentry.captureException(error);
          dispatch(orderFailure({ message: error.message || "Something went wrong" }));
        }
      });
  };
};

export const orderStarted = () => ({
  type: "ORDER_STARTED",
});

export const orderSuccess = (order) => ({
  type: "ORDER_SUCCESS",
  order: order,
});

export const orderFailure = (error) => ({
  type: "ORDER_FAILURE",
  error: error,
});

export const clearErrorMessage = () => ({
  type: "CLEAR_ERROR",
});

export const logStarted = () => ({
  type: "LOG_STARTED",
});

export const logSuccess = (order) => ({
  type: "LOG_SUCCESS",
  order: order,
});

export const logFailure = (error) => ({
  type: "LOG_FAILURE",
  error: error,
});
